module.exports = __webpack_public_path__ + "static/media/location-heading-marker.min.76e01796.svg";